/* eslint-disable no-param-reassign */
import { flow, applySnapshot } from 'mobx-state-tree';
import isEmpty from 'lodash/isEmpty';
import compact from 'lodash/compact';
import flattenDeep from 'lodash/flattenDeep';

import api from '~/api';
import { toMapById } from '~/mst/utils';
import type { IDistributionWidgetModel } from './model';

export default (self: IDistributionWidgetModel) => ({
  fetch: flow(function* fetch(params: { from?: number; to?: number } = {}) {
    try {
      self.startFetching();
      const payload = {
        node_id: [...self.node_id],
        data_point_id: [...(self.parameter?.data_point_ids || [])],
        ...params,
        // Averaged by the API, as for reports
        ...(self.aggregate && { aggregate: String(self.aggregate) })
      };
      const { data } = yield self.sync(api.search.nodes, payload);
      const linkedDataPointIds = compact(flattenDeep(data.map(({ data_points }) => data_points.map(({ linked }) => linked))));
      if (!isEmpty(linkedDataPointIds)) {
        const { data: linkedDataPoints } = yield self.sync(api.search.dataPoints, { data_point_id: linkedDataPointIds });
        applySnapshot(self.nodes, {
          models: toMapById(
            data.map((node) => ({
              ...node,
              data_points: [...node.data_points, ...linkedDataPoints.filter(({ node_id }) => node_id === node._id)]
            }))
          )
        });
      } else {
        applySnapshot(self.nodes, {
          models: toMapById(data)
        });
      }
      // Ranges up to now have no `to`
      self.period = params.from ? { from: params.from, to: params.to ?? Date.now() } : null;
      self.finishFetching();
    } catch (error) {
      self.failFetching(error);
    }
  })
});
